import { render, staticRenderFns } from "./mySourcingOfferDetails.vue?vue&type=template&id=6a96e506&scoped=true&"
import script from "./mySourcingOfferDetails.vue?vue&type=script&lang=js&"
export * from "./mySourcingOfferDetails.vue?vue&type=script&lang=js&"
import style0 from "./mySourcingOfferDetails.vue?vue&type=style&index=0&id=6a96e506&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a96e506",
  null
  
)

export default component.exports